import moment from 'moment'

export const formatDate = (dateInput: any, outputFormat: string, zone?: string) => {
    //TODO: timezone function need to be added.
    return moment(dateInput).format(outputFormat);
}

/**
 * Function to transform milliseconds value to a readable date time format
 * @param dataObject Is the object that contains the milli time format.
 * sample dataObject <pre> {Impression: [{key: '1566964800000', value: 333}, {...}], Users: [{...}, {...}] } </pre>
 * @param keyName is the identifier/position key properties where the milli can be found.
 */
export const transformMilliToDate = (dataObject, keyName) => {
    if (typeof dataObject != 'object') {
        console.log('[ Utils transformMilliToDate ] - An invalid object was passed.');
        return null
    };

    let keys = Object.keys(dataObject);
    keys.forEach(key => {
        Object.assign(dataObject[key], 
            dataObject[key].map(e => {
                if (e.hasOwnProperty(keyName)) e[keyName] = this.formatDate(+e[keyName], 'YYYY-MM-DD HH:mm:ss');
                return e;
            })
        )
    });
}

export const excludeKey = (dataObject, keyProp) => {
    if (typeof dataObject != 'object') throw new TypeError('[ Utils excludeKeys ] - Invalid data object was passed');

    let keys = Object.keys(dataObject);
    keys.forEach(mainKey => {
        Object.assign(dataObject[mainKey], dataObject[mainKey].filter(element => delete element[keyProp]));
    });
}